// import axios from 'axios';
// import auth from '../../Helpers/auth'
// import * as constants from '../../global/const'

const AccesoRapido = (props) => {

    const { titulo, descripcion, url, tipo, setMostrarProductos, setTipo } = props;
    // const [sucursalesAll, setsucursalesAll] = useState([]);
    const { open, setOpen } = props;
    // let { history } = props;

    // const getSucursales = () => {
    //     let user = JSON.parse(auth.getUsuario())
    //     axios.get(constants.GETSUCRUSALES + "?correo=" + user.email).then((response) => {
    //         setsucursalesAll(response.data);
    //     }).catch((err) => {
    //         console.log("sucursales ", err);
    //     })
    // }

    const handleProductos = () => {
        setTipo(titulo === 'Ofertas y Promociones' ? 2 : 1)
    }

    return (
        <div className="acceso-rapido-contenedor"
            onClick={
                1 == tipo
                    ?
                    () => {
                        (
                            "Menu" == titulo
                                ?
                                setOpen(!open)
                                : (
                                    "Mis puntos de venta" == titulo
                                        ?
                                        window.location.href = url
                                        :
                                        "Historial de pedidos" == titulo
                                            ?
                                            window.location.href = url
                                            :
                                            window.location.href = url
                                )
                        )
                        setMostrarProductos(false);
                    }
                    :
                    () => {
                        setMostrarProductos(true);
                    }
            }>
            <div className="acceso-rapido-contenedor-contenido" onClick={() => {
                            if (2 == tipo) {
                                setMostrarProductos(false);
                                setTipo('');
                                handleProductos()
                            }
                        }}>
                <h2>{titulo}</h2>
                {/* <p>{descripcion}</p> */}
                <div className="acceso-rapido-contenedor-contenido-icono">
                    <a
                        
                    ><i className="fa fa-sign-in" aria-hidden="true"></i></a>
                </div>
                {
                    2 == tipo
                    &&
                    <div className="acceso-rapido-cotenedor-contenido-cola">
                        <p>.</p>
                    </div>
                }
            </div>
        </div >
    )
}
export default AccesoRapido;
